import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import SearchInput from "../../components/SearchInput";
import DataTable, { type Column } from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import { useLieuxList } from "../../../hooks/useLieuxList";
import { useDeleteLieu } from "../../../hooks/useDeleteLieu";
import type { LieuResponse } from "../../../api/lieuxApi";

export default function LieuListPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const { data, isLoading } = useLieuxList({ search, page, size: 20, sort: "name,asc" });
  const remove = useDeleteLieu();

  const onDelete = (id: string) => {
    if (window.confirm("Supprimer définitivement ce lieu ?")) remove.mutate(id);
  };

  const columns: Column<LieuResponse>[] = [
    {
      key: "name",
      header: "Nom",
      render: (row) => (
        <Link to={`/admin/lieux/${row.id}`} className="bo-cell-link">
          {row.name}
        </Link>
      ),
    },
    {
      key: "address",
      header: "Adresse",
      render: (row) =>
        row.addressName ||
        [row.address?.street, row.address?.postcode, row.address?.city].filter(Boolean).join(", ") ||
        "—",
    },
    {
      key: "artists",
      header: "Artistes",
      render: (row) => row.artists?.length ?? 0,
    },
    {
      key: "actions",
      header: "",
      render: (row) => (
        <div className="bo-row-end">
          <Button variant="ghost" onClick={() => navigate(`/admin/lieux/${row.id}`)}>
            Éditer
          </Button>
          <Button variant="ghost" onClick={() => onDelete(row.id)}>
            Supprimer
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title="Lieux"
        description="Catalogue global des lieux du tenant, avec leurs artistes associés."
        actions={
          <Button variant="primary" onClick={() => navigate("/admin/lieux/new")}>
            + Nouveau lieu
          </Button>
        }
      />

      <div className="bo-toolbar">
        <SearchInput
          value={search}
          onChange={(v) => {
            setSearch(v);
            setPage(0);
          }}
          placeholder="Rechercher par nom, description, ville, rue…"
        />
      </div>

      <DataTable
        rows={data?.content}
        columns={columns}
        rowKey={(r) => r.id}
        loading={isLoading}
        emptyMessage="Aucun lieu pour le moment."
      />
      <Pagination page={page} totalPages={data?.totalPages ?? 0} onChange={setPage} />
    </div>
  );
}
